/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export let ComHubspotFeatureRolloutsCoreModelsRollouts;
(function (_ComHubspotFeatureRolloutsCoreModelsRollouts) {})(ComHubspotFeatureRolloutsCoreModelsRollouts || (ComHubspotFeatureRolloutsCoreModelsRollouts = {}));
export let ComHubspotFeatureRolloutsCoreModelsRolloutsChirp;
(function (_ComHubspotFeatureRolloutsCoreModelsRolloutsChirp) {})(ComHubspotFeatureRolloutsCoreModelsRolloutsChirp || (ComHubspotFeatureRolloutsCoreModelsRolloutsChirp = {}));
export const enrollRpc = {
  serviceName: 'com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc',
  rpcName: 'enroll',
  auth: 'app',
  fingerprint: '59lJ_u1DNyLkFRGNPsuzh5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateEnrollTypeRpc = {
  serviceName: 'com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc',
  rpcName: 'updateEnrollType',
  auth: 'app',
  fingerprint: 'IhTRrPGe4p29JMQePTNox5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const leaveRpc = {
  serviceName: 'com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc',
  rpcName: 'leave',
  auth: 'app',
  fingerprint: '59lJ_u1DNyK9JMQePTNox5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};